import { ProductType } from "../../../../common/interfaces/enums/ProductType";
import { IApiLifeClient } from "../../../interfaces/api/group/case/config/clients/IApiLifeClient";
import { IApiGroupCaseConfig } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfig";
import { IApiGroupCaseConfigLife } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfigLife";
import { IApiGroupCaseLife } from "../../../interfaces/api/group/case/IApiGroupCaseLife";
import { IClient } from "../../../../common/interfaces/IClient";
import ISettingClientLife from "../../../../common/interfaces/settings/clients/ISettingClientLife";
import { IQuoteSettingContainerLife } from "../../../../common/interfaces/settings/IQuoteSettingContainerLife";
import { IQuoteSettingsContainerBase } from "../../../../common/interfaces/settings/IQuoteSettingsContainerBase";
import EnumMapper from "../EnumMapper";
import { Client } from "./BaseClientMapper";
import {
    assembleMapper,
    localToRemoteMapper,
    remoteToLocalMapper
} from "./SettingMapper";

const mapRemoteClientToLocal = (client: IApiLifeClient[]): ISettingClientLife[] => {
    return client.map((c) => {
        return {
            ...Client.remoteToLocal(c),
            coverAmount: c.coverAmount,
            premiumStructure: EnumMapper.PremiumStructure.remoteToLocal(
                c.premiumStructure
            )
        };
    });
};

const mapRemoteSettingToLocal = (
    baseSettings: IQuoteSettingsContainerBase,
    extension: IApiGroupCaseLife
): IQuoteSettingContainerLife => {
    return {
        ...baseSettings,
        clients: mapRemoteClientToLocal(extension.clients),
        premiumStructure: EnumMapper.PremiumStructure.remoteToLocal(
            extension.clients[0]?.premiumStructure
        ),
        allowChildren: false,
        productType: ProductType.Life
    };
};

const mapLocalSettingToRemote = (
    baseSetting: IApiGroupCaseConfig,
    extension: IQuoteSettingContainerLife,
    clients: IApiLifeClient[]
): IApiGroupCaseConfigLife => {
    return {
        ...baseSetting,
        clients
    };
};

const mapLocalClientToRemote = (
    client: IClient,
    setting: IQuoteSettingContainerLife
): IApiLifeClient => {
    const settingClient = setting.clients.find((c) => c.personId === client.personId);

    return {
        ...Client.localToRemote(client),
        coverAmount: settingClient.coverAmount,
        premiumStructure: settingClient.premiumStructure
    };
};

const remoteToLocal = (settings: IApiGroupCaseLife): IQuoteSettingContainerLife =>
    remoteToLocalMapper(settings, mapRemoteSettingToLocal);

const localToRemote = (
    clients: IClient[],
    settings: IQuoteSettingContainerLife
): IApiGroupCaseConfigLife =>
    localToRemoteMapper(
        clients,
        settings,
        mapLocalSettingToRemote,
        mapLocalClientToRemote
    );

export default assembleMapper(remoteToLocal, localToRemote);
